import axios from "axios";

const getCommitteesMeetings = async (ids, type) => {
  const limit = 150;
  let allMeetings = [];
  let currentPage = 0;
  let totalPages = 1;

  try {
    while (currentPage < totalPages) {
      let endpoint = "";
      let requestBody = {};

      if (type === "standing") {
        endpoint = `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommitteeMeetings/search?limit=${limit}&offset=${currentPage}`;
        requestBody = { standingCommitteeIds: ids };
      } else if (type === "nonStanding") {
        endpoint = `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/nonStandingCommitteeMeetings/search?limit=${limit}&offset=${currentPage}`;
        requestBody = { nonStandingCommitteeIds: ids };
      } else {
        throw new Error("Invalid committee type");
      }

      const response = await axios.post(endpoint, requestBody);
      const data = response.data;
      
      // Check if response data has a content property or is already the array.
      const meetingsPage = data.content ? data.content : data;

      // Remove canceled meetings
      const validMeetings = (Array.isArray(meetingsPage) ? meetingsPage : []).filter(
        (meeting) => meeting.status !== "CANCELED"
      );

      allMeetings = allMeetings.concat(validMeetings);

      // If the API provides totalPages use it, otherwise assume a single page.
      totalPages = data.totalPages ? data.totalPages : 1;
      currentPage++;
    }
  } catch (error) {
    console.error("Error fetching committee meetings:", error);
  }

  return allMeetings;
};

export default getCommitteesMeetings;
